import * as types from '../mutation-types'
import router from '../../router'
import axios from 'axios'

const state = {
  isLoggedIn: !!localStorage.getItem('token'),
  sidebar: {
    opened: false,
    withoutAnimation: false
  },
  project: {
    timeframe: '28',
    filterBrandKeys: false,
    isLoading: true
  },
  config: {
    // googleMaps: {
    //   apiKey: 'AIzaSyBNAqPrTQoz9P4NBlDDyfxrnKiafkaL8iQ'
    // },
    windowMatchSizeLg: '(min-width: 992px)',
    palette: {
      primary: '#2CE8B5',
      danger: '#F9526E',
      info: '#57B8E5',
      success: '#A88FFF',
      warning: '#FFCF42',
      white: '#fff',
      black: '#000',
      fontColor: '#34495e',
      transparent: 'transparent',
      lighterGray: '#ddd'
    }
  },
  isLoading: true,
  subscription () {
    if (JSON.parse(localStorage.getItem('subscription')) && JSON.parse(localStorage.getItem('subscription')).status === 'active') {
      return true
    } else {
      return false
    }
  }
}

const mutations = {
  [types.CLOSE_MENU] (state) {
    if (document.documentElement.clientWidth < 992) {
      state.sidebar.opened = false
    }
  },
  [types.TOGGLE_SIDEBAR] (state, opened) {
     // only hide sidebar after click when mobile
    if (!window.matchMedia(state.config.windowMatchSizeLg).matches) {
      state.sidebar.opened = opened
    }

    // if (state.sidebar.sidebarHovered && opened) return
    // state.sidebar.opened = opened
    // state.sidebar.sidebarClicked = opened
  },
  [types.TOGGLE_SIDEBAR_FORCE] (state, opened) {
    state.sidebar.opened = opened
    state.sidebar.sidebarClicked = opened
  },
  [types.HOVER_SIDEBAR] (state, opened) {
    if (state.sidebar.sidebarClicked) return
    state.sidebar.sidebarHovered = opened
    state.sidebar.opened = opened
  },
  [types.TOGGLE_WITHOUT_ANIMATION] (state, value) {
    state.sidebar.withoutAnimation = value
  },
  [types.LOGIN] (state) {
    state.pending = true
  },
  [types.LOGIN_SUCCESS] (state) {
    state.isLoggedIn = true
    state.pending = false
  },
  [types.LOGOUT] (state) {
    state.isLoggedIn = false
  },
  [types.SUBSCRIPTION] (state, value) {
    state.subscription = value
  },
  setLoading (state, isLoading) {
    state.isLoading = isLoading
  },
  setTimeframe (state, timeframe) {
    state.project.timeframe = timeframe
  },
  setBrandFilter (state, filter) {
    state.project.filterBrandKeys = filter
  },
  setProjectLoading (state, isLoading) {
    state.project.isLoading = isLoading
  }
}

const actions = {
  closeMenu ({ commit }) {
    commit(types.CLOSE_MENU)
  },
  toggleSidebar ({ commit }, opened) {
    commit(types.TOGGLE_SIDEBAR, opened)
  },
  toggleSidebarClick ({ commit }, opened) {
    commit(types.TOGGLE_SIDEBAR_FORCE, opened)
  },
  hoverSidebar ({ commit }, opened) {
    commit(types.HOVER_SIDEBAR, opened)
  },
  isToggleWithoutAnimation ({ commit }, value) {
    commit(types.TOGGLE_WITHOUT_ANIMATION, value)
  },
  login ({ commit }, token) {
    commit(types.LOGIN) // show spinner
    return new Promise(resolve => {
      localStorage.setItem('token', token)
      commit(types.LOGIN_SUCCESS)
      resolve()
    })
  },
  isLoggedIn ({commit}) {
    return !!localStorage.getItem('token')
  },
  setSubscription ({commit}, subscription) {
    commit(types.SUBSCRIPTION, subscription)
    localStorage.setItem('subscription', JSON.stringify(subscription))
  },
  logout ({ commit }) {
    console.log('logout')
    axios.get(`user/logout`)
       .then((res) => {
         console.log(res)
         localStorage.removeItem('token')
         localStorage.removeItem('subscription')
         localStorage.removeItem('mainuser')
         localStorage.removeItem('user')
         commit(types.LOGOUT)
         router.push({ path: '/login' })
       })
       .catch((e) => this.handleErr(e))
  },
  makeAverage ({commit}, data) {
    let weeklyAvg = 0
    let weeklyData = []

    const doLoop = int => {
      for (var i = 0; i < int; i++) {
        weeklyData.push((weeklyAvg / int).toFixed(2))
      }
      weeklyAvg = 0
    }

    for (let index = 0; index < data.length; index++) {
      let day = data[index]
      weeklyAvg = weeklyAvg + parseFloat(day)
      if ((index + 1) % 7 === 0) doLoop(7)
      else if (index + 1 === data.length) {
        let remainder = data.length % 7
        if (remainder > 0) doLoop(remainder)
        else doLoop(7)
      }
    }

    return {
      backgroundColor: 'transparent',
      borderColor: '#b9b9b9',
      label: 'Avg. Pos',
      yAxisID: 'left-y-axis',
      pointRadius: 0,
      borderWidth: 1,
      steppedLine: true,
      data: weeklyData
    }
  }

}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js